// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import Carousel from 'stimulus-carousel'

import SearchFormController from "./search_form_controller.js"
application.register("search-form", SearchFormController)

import ItemFormController from "./item_form_controller.js"
application.register("item-form", ItemFormController)

import TomSelectController from "./tom_select_controller.js"
application.register("tom-select", TomSelectController)

import TurboModalController from "./turbo_modal_controller.js"
application.register("turbo-modal", TurboModalController)

import { Alert, Dropdown, Tabs, Modal, Toggle, Slideover } from "tailwindcss-stimulus-components"

application.register('carousel', Carousel)
application.register('alert', Alert)
application.register('dropdown', Dropdown)
application.register('tabs', Tabs)
application.register('modal', Modal)
application.register('toggle', Toggle)
application.register('slideover', Slideover)
